import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Modal, Icon, Button } from "semantic-ui-react";
import styles from "./styles.less";

class GlobalModal extends React.Component {
  render() {
    const {
      title,
      content,
      icon,
      closeBtnTitle,
      handleClose,
      isRtl,
      alignToTop,
      ...rest
    } = this.props;
    return (
      <Modal
        {...rest}
        className={cx(styles.globalModal, {
          [styles.rtl]: isRtl,
          [styles.alignToTop]: alignToTop
        })}
        onClose={handleClose}
        basic
        size="large"
      >
        <div>
          {title ? (
            <Modal.Header size="huge" className={styles.globalModalHeader}>
              <div className={styles.globalModalHeaderTitle}>
                <Icon name={icon || "warning circle"} /> {title}
              </div>
              {rest.closeOnEscape &&
                rest.closeOnRootNodeClick && (
                  <Modal.Actions
                    className={cx(styles.actions, { [styles.rtl]: isRtl })}
                  >
                    <Button
                      icon="close"
                      circular={!closeBtnTitle}
                      onClick={handleClose}
                      onKeyDown={handleClose}
                      inverted
                      content={closeBtnTitle}
                    />
                  </Modal.Actions>
                )}
            </Modal.Header>
          ) : (
            rest.closeOnEscape &&
            rest.closeOnRootNodeClick && (
              <Modal.Actions
                className={cx(styles.actions, { [styles.rtl]: isRtl })}
              >
                <Button
                  icon="close"
                  circular={!closeBtnTitle}
                  onClick={handleClose}
                  onKeyDown={handleClose}
                  inverted
                  content={closeBtnTitle}
                />
              </Modal.Actions>
            )
          )}
        </div>
        <hr className={styles.devider} />
        {content && (
          <Modal.Content className={styles.modalContent}>
            {content}
          </Modal.Content>
        )}
      </Modal>
    );
  }
}

GlobalModal.defaultProps = {
  alignToTop: false
};

GlobalModal.propTypes = {
  isRtl: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  closeBtnTitle: PropTypes.string,
  icon: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  alignToTop: PropTypes.bool
};

export default GlobalModal;



// WEBPACK FOOTER //
// ./src/components/common/GlobalModal/GlobalModal.js